import React, {useContext, useEffect, useRef, useState} from 'react';
import {useTranslation} from "react-i18next";
import PageTitle from "../../components/Commons/PageTitle";
import CardSummaryPayment from "../../components/Cards/CardSummaryPayment"
import Spinner from "../../components/UI/Spinner";
import UserContext from "../../context/user-context";
import axios from "../../axios-defaults";
import Currency from "../../components/Utils/Number/Currency";
import ByAccount from "../../components/Payment/ByAccount";
import ByFix from "../../components/Payment/ByFix";
import SubaccountDropdown from "../../components/Payment/SubaccountDropdown";
import ModalMxo from "../../components/UI/Modal";
import ByInvoice from "../../components/Payment/ByInvoice";
import PopupAdjustment from "../../components/Payment/Popup/PopupAdjustment";
import PaymentPopupV2 from "../../components/Payment/Popup/PaymentPopupV2";
import {useLocation} from 'react-router-dom'
import {userHaveSpecificPermission} from "../../components/Utils/UserHelper";
import Alert from "../../components/UI/Alerts/Alert";
import Helpbox from "../../components/UI/Helpboxes/Helpbox";
import {fireGTMPaymentEvent, returnTranslatedPaymentMethod} from "../../components/Utils/GTM/GTMHelper";
import UserHelper from "../../components/Utils/UserHelper";


const Payment = () => {
    const userContext = useContext(UserContext);

    /*if (!userHaveSpecificPermission(userContext.user, 'financial_data'))
        return <></>;*/

    const location = useLocation();
    const {t, i18n} = useTranslation();
    const [loadingInv, setLoadingInv] = useState(null);
    const [loadingSub, setLoadingSub] = useState(null);

    //Global to all
    const [subAccounts, setSubAccounts] = useState(null);
    const [percent, setPercent] = useState(0);
    const [amount, setAmount] = useState(0);
    const [total, setTotal] = useState(0);
    const [mode, setMode] = useState('');  // 'subaccount', 'fix', 'invoice'
    const [currSubSelected, setCurrentSubSelected] = useState([]); // For 'fix', 'invoice'
    const [theSelection, setTheSelection] = useState(null);
    const [limitTester, setLimitTester] = useState({min: 0, max: 0});
    const [allInvoicesGrouped, setAllInvoicesGrouped] = useState([]);

    const [allowedToPay, setAllowedToPay] = useState(null);

    //Specicif ByFix
    const [invoices, setInvoices] = useState([]);
    const [amountPossibility, setAmountPossibility] = useState([]);
    const [customBalance, setCustomBalance] = useState([]);

    //Modal Alert Setting
    const [showModal, setShowModal] = useState(false);
    const [modalTitle, setModalTitle] = useState(false);
    const [modalExtrasClass, setModalExtrasClass] = useState('');
    const [modalContent, setModalContent] = useState(false);
    const [hideFooter, setHideFooter] = useState(false);
    const [backDrop, setBackDrop] = useState(true);
    const [footerContent, setFooterContent] = useState('');

    useEffect(async () => {
        await axios.get("/accounts/unappliedPaymentExist")
            .then(response => {
                if (response.data.succeeded) {
                    //response.data.data.isUnappliedPaymentExist=false
                    setAllowedToPay(response.data.data);
                }
            }).catch(error => {
                console.log('[Payment.js] : Ajax error in allowedPayment()', error.message);
            });
    },[])

    useEffect(async () => {
        if (allowedToPay === null || allowedToPay?.isUnappliedPaymentExist === true) return;

        if (subAccounts === null) {
            setLoadingSub(true)
            getSubAccounts().finally(() => setLoadingSub(false));
        } else {
            if(allInvoicesGrouped.length !== 0 ){
                setLoadingSub(false);
                if (location.state && location.state.by) {
                    changeMode(location.state.by);
                }
            }
        }
    }, [subAccounts, location, allInvoicesGrouped, allowedToPay])

	useEffect(() => {
		fireGTMPaymentEvent('1_consultation',{mode : location.state && location.state.by ? returnTranslatedPaymentMethod(location.state.by) : ''});
	}, []);


    const changeMode = (mode) => {
        setTheSelection(null);
        setMode(mode);
        setAmount(0);
        setPercent(0);
        if (location.state && location.state.by) {
            location.state.by = mode
        }
        if(location.state && location.state.subaccount){
            handleSubAccountSelector(location.state.subaccount)
        }else{

            if (allInvoicesGrouped && allInvoicesGrouped.length === 1
                && currSubSelected.length !== 1
                && mode !== "subaccount") {
                handleSubAccountSelector(allInvoicesGrouped[0].subAccountCode);
            }else{
                setCustomBalance([]);
            }
        }
    }

    useEffect(() => {
        window.addEventListener("scroll", () => {
            let element = document.querySelector(".payment-action");
            if (element) {
                var y = window.scrollY;
                if (y >= 300 && !((window.innerHeight + window.scrollY) >= document.body.offsetHeight -
                    (document.querySelector("footer").getBoundingClientRect().height+60))) {
                    element.classList.add("_sticky")
                } else {
                    element.classList.remove("_sticky")
                }
            }

        });
    }, []);

    const getSubAccounts = async () => {
        await axios.get("/accounts/subaccounts")
            .then(response => {
                if (response.data.succeeded) {
                    let cleaned = response.data.data.filter(elem => elem.subAccountDisplayMode.code === 'A' ||
                        (elem.isOnlinePaymentAllowed && !elem.isDisabled && elem.totalBalance.value > 0)); //Only subaccount who can make payments + adj account
                    setSubAccounts(cleaned);
                    //setTotalAllSubAccounts(cleaned)
                    getAllInvoicesAndGroupBySubAccountCode(cleaned)
                }
            }).catch(error => {
                console.log('[Payment.js] : Ajax error in getSubAccounts()', error.message);
            });
    };

    const setTotalAllInvoices = (invoices) => {
        let total = 0;
        let arrayOfPossibility = [];
		let cummulativeInvoices = [];

        invoices.map(item => {
            total += item.balanceAmount.value;
            if (total > 0) {
				cummulativeInvoices.push(item);
                arrayOfPossibility.push({
					amount : total.toFixed(2),
					invoices : [...cummulativeInvoices]
				})
            }

        })
        setAmountPossibility(arrayOfPossibility);
        //setTotal(total);
    }

    const totalBySubAccount = (subAccountCode,subs,invoices) => {
        let indexInvoice = invoices.findIndex(x => x.subAccountCode === subAccountCode);

        let total = 0.00;
        if (invoices[indexInvoice] === undefined) return total;

        invoices[indexInvoice].items.map((item)=> {
            total += item.balanceAmount.value;
        });


        return total;
    }

    const setTotalAllSubAccounts = (subs,invoices) => {
        let total = 0;
        subs.map(element => {
            total += totalBySubAccount(element.subAccountCode,subs,invoices);
        });

        setTotal(total.toFixed(2));
    }

    const getInvoiceLines = async (sub) => {
        setLoadingInv(true);
        let query = `?`;

        sub.map((s, index) => {
            query += (index === 0 ? '' : '&') + `subAccountCodeList[]=${s}`;
        });

        let min = Math.max(...subAccounts.filter((item)=>sub.includes(item.subAccountCode)).map((item) => {
                    if (item.minimumOnlinePaymentCreditCard > item.minimumOnlinePaymentEFT) {
                        return item.minimumOnlinePaymentEFT
                    }
                    return item.minimumOnlinePaymentCreditCard;
            }
        ))

        let max = Math.min(...subAccounts.filter((item)=>sub.includes(item.subAccountCode)).map((item) => {
                    if (item.maximumOnlinePaymentCreditCard < item.maximumOnlinePaymentEFT) {
                        return item.maximumOnlinePaymentEFT
                    }
                    return item.maximumOnlinePaymentCreditCard;
            }
        ))

        setLimitTester({min: min, max: max});

        await axios.get(`/subAccounts/payableInvoices${query}`)
            .then(response => {
                if (response.data.succeeded) {
                    let adjustmentAccountInvoices = response.data.data.filter((item) => {
                        return item.subAccountCode[0] === '9' && item.subAccountCode.length === 9 && item.balanceAmount.value < 0
                    }).sort((a,b) => (a.balanceAmount.value*100) - (b.balanceAmount.value*100))

                    let otherInvoices = response.data.data.filter((item) => {
                        return !(item.subAccountCode[0] === '9' && item.subAccountCode.length === 9 && item.balanceAmount.value < 0)
                    }).sort(
                        (objA, objB) => Number(objB.statementDate) - Number(objA.statementDate),
                    ).reverse();
                    let sorted = [...adjustmentAccountInvoices,...otherInvoices]

                    /*
                    let sorted = response.data.data.sort(
                        (objA, objB) => Number(objB.statementDate) - Number(objA.statementDate),
                    ).reverse();*/
                    setInvoices(sorted);
                    setTotalAllInvoices(sorted)
                    setLoadingInv(false);
                }
            }).catch(error => {
                console.log('[Payment.js] : Ajax error in getInvoiceLines()', error.message);
            });
    };

    const getAllInvoicesAndGroupBySubAccountCode = async (selection) => {
        setLoadingInv(true);
        let query = "?";
        selection.map((s, index) => {
            query += (index === 0 ? '' : '&') + `subAccountCodeList[]=${s.subAccountCode}`;
        })
        await axios.get(`/subAccounts/payableInvoices${query}`)
            .then(response => {
                if (response.data.succeeded) {
                    let _allInvoicesGrouped = Object.values(response.data.data.reduce((acc, item) => {
                        if (!acc[item.subAccountCode]) acc[item.subAccountCode] = {
                            subAccountCode: item.subAccountCode,
                            items: []
                        };
                        acc[item.subAccountCode].items.push(item);
                        return acc;
                    }, {}));

                    setAllInvoicesGrouped(_allInvoicesGrouped)
                    setTotalAllSubAccounts(selection,_allInvoicesGrouped)

                }
            }).catch(error => {
                console.log('[Payment.js] : Ajax error in getInvoiceLines()', error.message);
            }).finally(() => {setLoadingInv(false)});
    }

    const handleSubAccountSelector = (sub) => {

        if (Array.isArray(sub)) {
            if(sub.length !== 0){
                setCurrentSubSelected(sub)
                getInvoiceLines(sub);
            }else{
                setCurrentSubSelected([]);
                if(mode === "fix"){
                    document.getElementById("inputfixamount").value = 0;
                }
                setAmount(0);
            }
        } else {
            let array = [...currSubSelected];
            if (array.length !== 0 && array.includes(sub)) {
                let index = array.indexOf(sub)
                if (index !== -1) {
                    array.splice(index, 1);
                    if (array.length !== 0) {
                        setCurrentSubSelected(array);
                        getInvoiceLines(array).then(() => {
                            if(mode === 'fix') document.getElementById("inputfixamount").value = 0
                        })

                    } else {
                        setCurrentSubSelected([])
                        setAmountPossibility([]);
                        setAmount(0)
                    }
                }
            } else {
                array.push(sub);
                setCurrentSubSelected(array);
                if(mode==='fix'){
                    setCustomBalance([])
                    document.getElementById("inputfixamount").value = 0;
                }
                getInvoiceLines(array);
            }
        }

    }

    const handleFixAmount = (value) => {
        //setCustomBalance([])
        setPercent((Number(value) / Number(total)) * 100)
        setAmount(Number(value));
        buildCustomBalance(value);
    }
    const buildCustomBalance = (value) =>{
        let temp_customBalance = [];
        let valueToTest = parseFloat(value);
        invoices.map((item) => {
            if (valueToTest > 0) {
                if (temp_customBalance.length === 0) {
                    temp_customBalance.push({
                        invoiceNumber: item.invoiceNumber,
                        valueSend: valueToTest,
                        amount: parseFloat(item.balanceAmount.value),
                        over: parseFloat(item.balanceAmount.value) < valueToTest,
                        remaining: parseFloat(valueToTest - parseFloat(item.balanceAmount.value))
                    })
                } else {
                    let lastelem = temp_customBalance[temp_customBalance.length - 1]
                    if (parseFloat(lastelem.remaining) > 0 && lastelem.over) {
                        temp_customBalance.push({
                            invoiceNumber: item.invoiceNumber,
                            valueSend: parseFloat(lastelem.remaining),
                            amount: parseFloat(item.balanceAmount.value),
                            over: parseFloat(item.balanceAmount.value) < parseFloat(lastelem.remaining),
                            remaining: parseFloat((parseFloat(lastelem.remaining) - parseFloat(item.balanceAmount.value)).toFixed(2))
                        })
                    }
                }
            }
        });

        setCustomBalance(temp_customBalance);
        return temp_customBalance;
    }
    const handleBySubAccount = (array) => {

        if (array.total > 0) {
            setLimitTester({min: array.min, max: array.max})
            setTheSelection(array.selection);
            setPercent((array.total / total) * 100);
            setAmount(array.total);

        } else {
            setPercent(0);
            setAmount(0);
        }
    }

	const getSelectedInvoices = (selectedAmount) => {
		let _customBalance = buildCustomBalance(selectedAmount);
		let getTheSelection = invoices.filter(o1 =>
			_customBalance.some(o2 => o1.invoiceNumber == o2.invoiceNumber));

		getTheSelection.forEach((invoice) => {
			let balance = _customBalance.find(bal => bal.invoiceNumber === invoice.invoiceNumber);
			invoice.paidAmount = balance.remaining >= 0 ? balance.amount : balance.valueSend;
		})

		return getTheSelection;
	}

    const handleByInvoice = (array) => {
        if (array.total > 0) {
            setTheSelection(array.selection);
            setPercent((array.total / total) * 100)
            setAmount(array.total);
        } else {
            setPercent(0);
            setAmount(0);
        }
    }

    const validationSecondStepFixedPayment = (value) => {
        setShowModal(true);
        setModalTitle(t('payment.popup.paymentprocess.step1_title'));
        setModalExtrasClass('ultimate-modal--full');
        setBackDrop('static');
        setHideFooter(false);

		let getTheSelection = getSelectedInvoices(value)

        setTheSelection(getTheSelection)

        setModalContent(<PaymentPopupV2
            modal_func={'payment'}
            subAccounts={subAccounts}
            userAccount={userContext.user.account}
            amount={value}
            type={mode}
            theSelection={getTheSelection}
            modalActionClose={handleCloseModal}
        />);
    }

    const validationFirstStepPayment = () => {
		fireGTMPaymentEvent('2_initialisation', {mode: returnTranslatedPaymentMethod(mode)});
        if (mode === 'fix') {
            if (!amountPossibility.find(item => parseFloat(item.amount) === amount)) {
                setShowModal(true);
                setModalTitle(t('payment.popup.titlewarning'));
                setBackDrop(true);
                setHideFooter(true)

                let needle;
                let cleanedPossibility = [...amountPossibility];
				let indexNeedle;
				if (amountPossibility.length >= 2) {

                    cleanedPossibility = [];
                    needle = amountPossibility.findLast(item=> item.amount < amount)
					let showPreviousInvoice = true;
					if (!needle){
						showPreviousInvoice = false
						needle = amountPossibility[0]
					}

                    indexNeedle = amountPossibility.findIndex((item) =>
					{
						return item.invoices.slice(-1)[0].invoiceNumber === needle.invoices.slice(-1)[0].invoiceNumber
					});

                    if (!showPreviousInvoice) {
						let firstInvoiceEqualOrHigher = amountPossibility.find(item => item.amount > amount)
                        cleanedPossibility.push(firstInvoiceEqualOrHigher);
                    } else if (indexNeedle === amountPossibility.length - 1) {
                        cleanedPossibility.push(amountPossibility[amountPossibility.length - 1]);
                    } else {
                        if (amountPossibility[indexNeedle] > amount) {
                            cleanedPossibility.push(amountPossibility[indexNeedle -1], amountPossibility[indexNeedle]);
                        }
                        else {
                            cleanedPossibility.push(amountPossibility[indexNeedle], amountPossibility[indexNeedle + 1]);
                        }
                    }
                }

                let customRange = false;
                let cleanedPossibilityUnderMax = cleanedPossibility.filter((item)=> item.amount <= limitTester.max);
                if(cleanedPossibility.length !== cleanedPossibilityUnderMax.length ){
                    customRange = true;
                    if(cleanedPossibilityUnderMax.length === 0){
                        cleanedPossibility = [];
                        let cleanedPossibilityUnderMax = amountPossibility.filter((item)=> item.amount <= limitTester.max);
                        if(amountPossibility.length !== 0){
                            if(cleanedPossibilityUnderMax.length >= 2){
                                cleanedPossibility.push(cleanedPossibilityUnderMax[cleanedPossibilityUnderMax.length-2],cleanedPossibilityUnderMax[cleanedPossibilityUnderMax.length-1] );
                            }else{
                                cleanedPossibility.push(cleanedPossibilityUnderMax[0]);
                            }
                        }
                    }else{
                        cleanedPossibility = cleanedPossibilityUnderMax;
                    }
                }

				if (indexNeedle === 0 || indexNeedle === amountPossibility.length - 1) {
					cleanedPossibility.splice(0,0,{
						type: 'partial',
						amount: parseFloat(amount),
						invoices: [...cleanedPossibility.slice(-1)[0].invoices]
					})
				} else {
					cleanedPossibility.splice(1,0,{
						type: 'partial',
						amount: parseFloat(amount),
						invoices: [...cleanedPossibility.slice(-1)[0].invoices]
					})
				}

                setModalContent(
                    <PopupAdjustment
						amountPossibility={cleanedPossibility}
						invoices={invoices}
                        isCustomRange={customRange}
                        amount={amount}
                        needle={needle}
                        paymentOption={mode}
                        limitTester={limitTester}
                        setAmount={setAmount}
						getSelectedInvoices={getSelectedInvoices}
                        validationSecondStepFixedPayment={validationSecondStepFixedPayment}
                        handleFixAmount={handleFixAmount}
                        handleCloseModal={handleCloseModal}
                    />)
                setFooterContent(false);

            } else {
                validationSecondStepFixedPayment(amount);
            }


        } else if (mode === 'subaccount') {
            let array = {};
            theSelection.map((item) => {
                array[item.subAccountCode] = item
            });
            let invoices = [];
            allInvoicesGrouped.filter(item=>array.hasOwnProperty(item.subAccountCode)).map((item)=> {
                item.items.map((item) => {
                    // if cardlock or harnois only include invoices with statement dates
                    if (["K","H"].includes(array[item.subAccountCode].subAccountDisplayMode.code)) {
                        if (item.statementDate !== null) {
                            invoices.push(item)
                        }
                    }
                    else {
                        invoices.push(item)
                    }
                })
            })

			invoices.forEach((invoice) => {
				invoice.paidAmount = invoice.balanceAmount.value;
			})

            setShowModal(true);
            setModalTitle(t('payment.popup.paymentprocess.step1_title'));
            setModalExtrasClass('ultimate-modal--full');
            setBackDrop('static');
            setHideFooter(false);
            setModalContent(<PaymentPopupV2
                modal_func={'payment'}
                subAccounts={subAccounts}
                userAccount={userContext.user.account}
                amount={amount}
                type={'subaccount'}
                theSelection={invoices}
                modalActionClose={handleCloseModal}
            />);

        } else if (mode === 'invoice') {
            theSelection.forEach((invoice) => {
				invoice.paidAmount = invoice.balanceAmount.value;
			})
            setShowModal(true);
            setModalTitle(t('payment.popup.paymentprocess.step1_title'));
            setModalExtrasClass('ultimate-modal--full');
            setBackDrop('static');
            setHideFooter(false);
            setModalContent(<PaymentPopupV2
                modal_func={'payment'}
                userAccount={userContext.user.account}
                subAccounts={subAccounts}
                amount={amount}
                type={mode}
                theSelection={theSelection}
                modalActionClose={handleCloseModal}
            />);
        }

    }

    const handleCloseModal = async () => {
        setShowModal(false);
        setModalContent(false);

        // only payment popups have this property
        if (modalContent?.props?.modalActionClose !== undefined) {
            setLoadingSub(true)
            //setTotal(0.00)
            getSubAccounts().then(() => { changeMode(mode) });
            await getInvoiceLines(currSubSelected);
        }

    }

    const handleShowModal = () => setShowModal(true);

    const validationBtnPay = () => {
        if (amount === null || amount === 0) {
            return true;
        } else {
            if(amount >= limitTester.min && amount <= limitTester.max) {
                return false;
            }else {
                return true;
            }
        }
    }

    const toolTipText = () => {

        if (parseFloat(amount) === 0.00) {
            return t("popup.addamount");
        } else if (amount <= limitTester.min) {
            return t("popup.underminimumpaimentlimit");
        } else if (amount >= limitTester.max) {
            return t("popup.overmaximumpaimentlimit");
        } else {
            return false
        }
    }

    let onlySubAccountCodeForInvoices = allInvoicesGrouped.map(item=>item.subAccountCode);

    return (
        <React.Fragment>
            <div className="container container--larger">
                <div className="row flex flex--wrap flex--align-baseline">
                    <div className="col-12">
                        <PageTitle title={t('breadcrumbs.payment')}/>
                    </div>
                </div>


                {userContext.user.account !== null ?
                    <React.Fragment>
						<div className="row section--padding--top--20">
							{/*TODO: Check if payment type*/}
							{userContext.user.account.hasPreAuthorizedAccount !== true && userContext.user.infos && userContext.user.infos.permission !== 'limited' &&
								<div className="col-lg-6">
									<Helpbox type={userContext.user.account.classification.code !== 'RES' ? 'ppa-2' : 'budget'} cta={true} column={true}/>
								</div>
							}
							{userHaveSpecificPermission(userContext.user, 'financial_data') && (userContext.user.infos && userContext.user.infos.permission !== 'limited') ?
								<div
									className={!userContext.user.account.hasPreAuthorizedAccount && userContext.user.infos && userContext.user.infos.permission !== 'limited' ? "col-lg-6" : "col-lg-12"}>
									<Helpbox type="invoice" cta={true}
											 column={!userContext.user.account.hasPreAuthorizedAccount && userContext.user.infos && userContext.user.infos.permission !== 'limited'}/>
								</div>
							: null}
						</div>
						<CardSummaryPayment
							account={userContext.user.account}
							percent={percent}
							amount={amount}
							total={total}
						/>
						{allowedToPay === null && <Spinner/>}
						{allowedToPay?.isUnappliedPaymentExist === true &&
							<Alert type="warning" item={{
								type: 'warning',
								additionalClasses: 'message message',
								customIcon: 'far fa-info-circle',
                                text: (i18n.language === 'en')?allowedToPay.notAllowedOnlinePaymentMessage.descriptionEn:allowedToPay.notAllowedOnlinePaymentMessage.descriptionFr
                            }}/>
                        }
                        {allowedToPay?.isUnappliedPaymentExist === false && (total*100) > 0 &&
                            <>
                                <div className="payment-toggler">
                                    <div className="payment-toggler__inner">
                                            <button className={`btn btn--outline mr-3 ${mode === 'fix' && 'active'}`}
                                                    onClick={() => {
                                                        changeMode('fix');
                                                    }}>
                                                {t("payment.btn.byfix")}
                                            </button>
                                            <button className={`btn btn--outline mr-3 ${mode === 'subaccount' && 'active'}`}
                                                    onClick={() => {
                                                        changeMode('subaccount');
                                                    }}>
                                                {t("payment.btn.byaccount")}
                                            </button>
                                            <button className={`btn btn--outline mr-3 ${mode === 'invoice' && 'active'}`}
                                                    onClick={() => {
                                                        changeMode('invoice');
                                                    }}>
                                                {t("payment.btn.byinvoice")}
                                            </button>
                                    </div>
                                </div>
                            </>
                        }
                    </React.Fragment> : <Spinner/>
                }
                {(total*100) > 0 &&
                    <>
                    {
                        (!loadingSub && subAccounts !== null && mode === 'fix') &&
                        <div className={'payment-input d-flex flex-wrap justify-content-between'}>
                            <div className="d-flex flex-column flex-md-row align-items-start align-items-md-center mb-2">
                                <h2 className="headline headline--section mb-3 mb-md-0">{t("payment.choiceamount")}&nbsp;:&nbsp;</h2>
                                <div
                                    className={`payment-input__wrapper ${i18n.language === "fr" ? 'payment-input__wrapper--right' : 'payment-input__wrapper--left'}`}>
                                    <input type="number" id="inputfixamount" onFocus={(event) => event.target.select()} disabled={currSubSelected.length === 0}
                                           max={total} min={0.00} defaultValue={0.00} step="any"
                                           onWheel={(e) => e.target.blur()}
                                           onBlur={(e) => e.target.value = parseFloat(e.target.value).toFixed(2)}
                                           onChange={(e) => {
                                                   if (e.target.value !== "" && e.target.value.replace(/[^\d.,]/g, '') !== "") {
                                                   let value = e.target.value.replace(/[^\d.,]/g, '');
                                                   value = parseFloat(value);
                                                   if (value < 0) {
                                                       e.target.value = 0.00;
                                                   } else if (value >= total) {
                                                       value = total;
                                                       e.target.value = value;
                                                   }
                                                   handleFixAmount(parseFloat(value).toFixed(2))
                                               } else {
                                                   e.target.value = 0.00;
                                                   handleFixAmount(0.00)
                                               }
                                           }}/>
                                </div>
                            </div>
                            <div className="d-flex align-items-center mt-2 mt-sm-0 mb-2">
                                <SubaccountDropdown subAccounts={subAccounts} current={currSubSelected}
                                                    allInvoicesGrouped={allInvoicesGrouped}
                                                    actionClick={handleSubAccountSelector}/>
                            </div>
                        </div>
                    }

                    {mode !== '' && <div>

                        {
                            mode === 'fix' && currSubSelected.length !== 0 && <React.Fragment>
                                {!loadingInv && invoices !== null ?
                                    <div className="payment-content">
                                        <h2 className="headline headline--section headline--margin--20">
                                            {t("payment.invoices")}</h2>
                                        {<ByFix data={invoices}
                                               customBalance={customBalance}/>}
                                    </div> : <div className="payment-content">
                                        <Spinner/>
                                    </div>}
                            </React.Fragment>
                        }

                        {
                            mode === 'subaccount' && <React.Fragment>
                                {!loadingSub && subAccounts !== null && allInvoicesGrouped !== null ?
                                    <div className="payment-content">
                                        <h2 className="headline headline--section headline--margin--30">
                                            {t("payment.selectaccount")}</h2>
                                        <ByAccount subAccounts={subAccounts.filter((item)=>onlySubAccountCodeForInvoices.includes(item.subAccountCode))}
                                                   locationState={location}
                                                   allInvoicesGrouped={allInvoicesGrouped}
                                                   handleBySubAccount={handleBySubAccount}/>
                                    </div>
                                    : <div className="payment-content">
                                        <Spinner/>
                                    </div>}
                            </React.Fragment>
                        }

                        {
                            mode === 'invoice' && <React.Fragment>
                                <div className="payment-content">
                                    <div className="d-flex flex-wrap justify-content-between align-items-baseline mb-3">
                                        <h2 className="headline headline--section headline--margin--20">
                                            {t("payment.selectinvoices")}</h2>
                                        {
                                            !loadingSub && subAccounts !== null && <React.Fragment>
                                                <SubaccountDropdown subAccounts={subAccounts}
                                                                    allInvoicesGrouped={allInvoicesGrouped}
                                                                    current={currSubSelected}
                                                                    actionClick={handleSubAccountSelector}/>
                                            </React.Fragment>
                                        }
                                    </div>
                                    {
                                        currSubSelected.length !== 0 && <React.Fragment>
                                            {!loadingInv && invoices !== null ?
                                                <ByInvoice data={invoices}
                                                           locationState={location}
                                                           handleByInvoice={handleByInvoice}/> : <Spinner/>}
                                        </React.Fragment>
                                    }
                                </div>
                            </React.Fragment>
                        }

                    </div>}

                    {mode !== '' && (currSubSelected.length !== 0 || mode === 'subaccount') ?
                        <div className="payment-action d-flex justify-content-end">
                            <div className="d-flex flex-column payment-action__container" style={{minWidth: "215px"}}>
                                <div className="d-flex mb-3 justify-content-center">
                                    <strong>Total : <Currency value={amount}/></strong>
                                </div>

                                <div className={validationBtnPay() ? 'tooltip-hovering' : ''}>
                                    {validationBtnPay() ? <span className="error-tooltip">{toolTipText()}</span> : null}
                                    <button className="btn btn--raised btn--raised--red"
                                            onClick={validationFirstStepPayment}
                                            disabled={validationBtnPay()}>
                                        {t("payment.btn.pay")}&nbsp;&nbsp;<i className="far fa-angle-right"/>
                                    </button>
                                </div>


                            </div>
                        </div> : <React.Fragment><br/><br/><br/><br/><br/></React.Fragment>
                    }
                    </>
                }
                {Math.round(total) === 0 && (loadingInv || loadingSub) && <Spinner />}
                <ModalMxo title={modalTitle}
                          show={showModal}
                          hideFooter={hideFooter}
                          footerActions={footerContent}
                          backDrop={backDrop}
                          extrasClass={modalExtrasClass}
                          onHide={handleCloseModal}
                          onShow={handleShowModal}>
                    {modalContent}
                </ModalMxo>

            </div>
        </React.Fragment>
    )
};

export default Payment;
